export const DEFAULT_MARKUP = 5;

export const DEFAULT_TXN_VALUE = 10000;

export const USD_TO_INR_RATE = 83;

export const PAYPAL_FEES = 5;

export const CURRENCY_CONVERSION_FEES = 1.75;

export const ENABLE_FOREX_MARKUP = 'ENABLE_FOREX_MARKUP';

export const DISABLE_FOREX_MARKUP = 'DISABLE_FOREX_MARKUP';

export const DEFAULT_CON_FEE = 0;

export const DEFAULT_FOREX_INPUT_VALUE = 0;

export const FOREX_MARKUP_VALIDATION = {
  MIN: 0.01,
  MAX: 5.00,
};

export const FOREX_MARKUP_BREAKDOWN = [
  {
    label: 'Transaction value {A} (INR)',
    key: 'transactionValue',
    // withoutMarkup: '10,000.00', // Minimum of 10K or Maximum applicable transaction amount value
    // withMarkup: '10,000.00', // wihoutMarkup + Recoverable Transaction charges value - e.g. 4% 0f 10000
  },
  {
    label: `Customer pays  via  paypal (USD [ 1 USD = ${USD_TO_INR_RATE} INR]) {B}`,
    key: 'paypalValue',
    // withoutMarkup: '120.48', // just above val / 83
    // withMarkup: '126.82', // just above val / 83
  },
  {
    label: `Paypal fees deducted (USD at ${PAYPAL_FEES}%)`,
    key: 'paypalFees',
    // withoutMarkup: '-6.02', // 5% (Paypal Transaction Charges field) of just above val
    // withMarkup: '-6.34', // 5% (Paypal Transaction Charges field) of just above val
  },
  {
    label: `Paypal currency conversion fees  (USD  at ~ ${CURRENCY_CONVERSION_FEES}%)`,
    key: 'currencyConversionFees',
    // withoutMarkup: '-2.00', // 1.75% (Hardcoded) of just row 2
    // withMarkup: '-2.22', // 1.75% (Hardcoded) of just row 2
  },
  {
    label: 'Amount settled to merchant in USD',
    key: 'amountSettled',
    // withoutMarkup: '112.46', // Row 2 - (Row 3 + Row 4)
    // withMarkup: '118.26', // Row 2 - (Row 3 + Row 4)
  },
  {
    label: 'Amount settled to merchant in INR {C}',
    key: 'amountSettledInINR',
    // withoutMarkup: '9334.18', // Just above value * 83
    // withMarkup: '9815.79', // Just above value * 83
  },
  {
    label: 'Effective cost of transaction for merchant',
    key: 'effectiveCost',
    // withoutMarkup: '665.82', // Row 1 - Just above val
    // withMarkup: '184.21', // Row 1 - Just above val
  },
  {
    label: 'Effective cost of transaction for merchant',
    key: 'effectiveCostInPercentage',
    // withoutMarkup: '6.66 %', // (Just above val / First Column) * 100
    // withMarkup: '1.84 %', // (Just above val / First Column) * 100
  },
];

export const FOREX_MARKUP_KNOW_MORE_LINK = 'https://docs.cashfree.com/docs/paypal-international-collections';

export const CONNECT_PAYPAL_RADIO_OPTIONS = [
  {
    label: 'Already have a seller account with Paypal',
    name: 'paypalAccount',
    value: 'login',
    dataEventName: 'Connect_Paypal_Account_Radio_Button',
    dataEventProperties: JSON.stringify({ value: 'login to paypal' }),
  },
  {
    label: 'Want to signup for Paypal',
    name: 'paypalAccount',
    value: 'signup',
    dataEventName: 'Connect_Paypal_Account_Radio_Button',
    dataEventProperties: JSON.stringify({ value: 'signup for paypal' }),
  },
];
